module.exports = __webpack_public_path__ + "legal/VERİ SORUMLUSUNA BAŞVURU TEBLİĞ.72cb45b2.pdf";